import React, { useState } from "react"
import ReactApexChart from "react-apexcharts"

const ChargerStatusChart = ({ chargerStatus }) => {
  const [options] = useState({
    chart: {
      type: "pie",
      fontFamily: `'Poppins', sans-serif`,
      foreColor: "#000000",
      width: "100%",
      height: 430,
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        dataLabels: {
          minAngleToShowLabel: 0,
        },
      },
    },
    labels: ["Available", "Unavailable", "Preparing", "Charging", "Faulted"],
    fill: {
      colors: [
        "#81C784", // Available – Green (Positive)
        "#E57373", // Unavailable – Red (Negative)
        "#FFD54F", // Preparing – Yellow (Warning)
        "#64B5F6", // Charging – Blue (Action/Info)
        "#BA68C8", // Faulted – Purple (Error or Inactive State)
      ],
    },
    stroke: {
      width: 0,
    },
    title: {
      text: "Charger Status",
      offsetX: -10,
      style: {
        fontSize: "18px",
        fontWeight: "500",
        color: "#263238",
      },
    },
    tooltip: {
      enabled: true,
      theme: "light",
      style: {
        fontSize: "14px",
        fontFamily: "Poppins, sans-serif",
      },
      fillSeriesColor: false,
      custom: function ({ series, seriesIndex, w }) {
        const labels = w.globals.labels
        const values = series[seriesIndex]
        const bgColors = [
          "#E8F5E9", // Available – light green
          "#FFEBEE", // Unavailable – light red
          "#FFFDE7", // Preparing – light yellow
          "#E3F2FD", // Charging – light blue
          "#F3E5F5", // Faulted – light purple
        ]

        const textColors = [
          "#2E7D32", // Available
          "#C62828", // Unavailable
          "#F57F17", // Preparing
          "#1565C0", // Charging
          "#6A1B9A", // Faulted
        ]

        return `
          <div style="
            background: ${bgColors[seriesIndex]};
            color: ${textColors[seriesIndex]};
            padding: 8px 12px;
            border-radius: 8px;
            border: 0 !important;
            box-shadow: none;
            font-weight: 500;
          ">
            ${labels[seriesIndex]}: ${values}
          </div>
        `
      },
    },
    legend: {
      show: true,
      fontWeight: "500",
      position: "bottom",
      markers: {
        size: 0,
      },
      itemMargin: {
        horizontal: 10,
      },
      formatter: function (seriesName, opts) {
        const icons = [
          '<i class="icon_main checked_circle" style="background-color: #81C784;"></i>', // Available
          '<i class="icon_main cross_circle" style="background-color: #E57373;"></i>', // Unavailable
          '<i class="icon_main preparing" style="background-color: #FFD54F;"></i>', // Preparing
          '<i class="icon_main ev_vehicles" style="background-color: #64B5F6;"></i>', // Charging
          '<i class="icon_main bug" style="background-color: #BA68C8;"></i>', // Faulted
        ]
        return `${icons[opts.seriesIndex]} ${seriesName}`
      },
      onItemHover: {
        highlightDataSeries: false,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
    },
  })

  const series = [
    chargerStatus?.available || 0,
    chargerStatus?.unavailable || 0,
    chargerStatus?.preparing || 0,
    chargerStatus?.charging || 0,
    chargerStatus?.faulted || 0,
  ]

  return (
    <>
      <ReactApexChart
        className="piechart"
        options={options}
        series={series}
        type="pie"
        height={430}
      />
    </>
  )
}

export default ChargerStatusChart
